import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from '../../hook/Translation';
import HalfSizeBanner from '../../components/Banners/HalfSizeBanner';
import TextBtnSection from '../../components/Section/TextBtnSection';

export default function FaceDecolate() {
    const { t } = useTranslation();
    return (
        <Box pb={'50px'}>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'text.secondary'}>
                        <Box component={'img'} alt={'Essence-of-two.png'}src={`${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69f85924586592.80887260.jpg`} loading='lazy' width={1} height={1} className='fitCover'  />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    // titleSize={{ md: 8, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                       type: t('bodyherapies'),
                        title: t('facedecollete.mainTitle'),
                        description: t('facedecollete.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e Hot Stone")}`,
                        learn: "",
                        price: `${t('price_session')} €40 - 30min`

                    }}
                />
            </Box>
          
            {/* <Grid container gap={{md: '80px', xs: '50px'}} className='generalContainer' sx={{ marginX: 'auto', marginY: '80px' }} marginTop={{md: '110px', xs: '50px'}} mb={{md: '120px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <DoubleAccordion data={accodirons} />
                </Grid>
            </Grid> */}

        </Box>
    )
}
